export default "__VITE_ASSET__D_SRumyh__";